import { Link } from 'react-router-dom';

const companyLinks = [
  { label: 'About', to: '/about' },
  { label: 'Innovation', to: '/innovation' },
  { label: 'Contact', to: '/contact' },
  { label: 'Client Portal', to: '/client-portal' },
];

const capabilityLinks = [
  { label: 'Financial Control', to: '/capabilities' },
  { label: 'Strategic Planning', to: '/capabilities' },
  { label: 'Reporting & Visibility', to: '/capabilities' },
  { label: 'Automation', to: '/capabilities' },
];

const serviceLinks = [
  { label: 'Payroll & Compliance', to: '/payroll-compliance' },
  { label: 'Industries', to: '/industries' },
  { label: 'Capital Partners', to: '/capital-partners' },
  { label: 'ScapeSource', to: '/innovation' },
];

export default function Footer() {
  return (
    <footer className="dark-grid-bg" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">

          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="mb-4">
              <div className="logo-text text-white text-xl tracking-wider">BOSFED®</div>
              <div className="text-[9px] text-slate-500 tracking-[0.2em] uppercase font-semibold mt-0.5">
                Boston Federal
              </div>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed max-w-xs">
              Reimagining financial control for the next generation of business.
            </p>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white text-[10px] font-bold uppercase tracking-[0.2em] mb-5">Company</h4>
            <ul className="space-y-3">
              {companyLinks.map(l => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, '-')}`}
                    className="text-slate-400 text-sm hover:text-[#0ABFBC] transition-colors duration-200"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Capabilities */}
          <div>
            <h4 className="text-white text-[10px] font-bold uppercase tracking-[0.2em] mb-5">Capabilities</h4>
            <ul className="space-y-3">
              {capabilityLinks.map(l => (
                <li key={l.label}>
                  <Link
                    to={l.to}
                    data-testid={`footer-cap-${l.label.toLowerCase().replace(/\s+/g, '-')}`}
                    className="text-slate-400 text-sm hover:text-[#0ABFBC] transition-colors duration-200"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white text-[10px] font-bold uppercase tracking-[0.2em] mb-5">Services</h4>
            <ul className="space-y-3">
              {serviceLinks.map(l => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-svc-${l.label.toLowerCase().replace(/\s+/g, '-').replace(/&/g, '')}`}
                    className="text-slate-400 text-sm hover:text-[#0ABFBC] transition-colors duration-200"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-white/[0.06] pt-6 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-slate-600 text-xs">
            © {new Date().getFullYear()} Boston Federal Financial. All rights reserved.
          </p>
          <p className="text-slate-600 text-xs">
            BOSFED® is a registered trademark of Boston Federal Financial.
          </p>
        </div>
      </div>
    </footer>
  );
}
